import {mapActions, mapGetters} from 'vuex';
import {camelCase, intersectionBy} from 'lodash';

import MainSelect from '@/components/atoms/main-select/index.vue'
import MultipleSelect from '@/components/atoms/multiple-select/index.vue'
import Autocomplete from '@/components/features/autocomplete/index.vue'
import {seo} from '@/mixins/seo'
import {translationUtils} from '@/utils/translations'

export default {
	name: 'profile-settings',
	mixins: [seo],
	data() {
		return {
			payload			: {
				country				: '',
				formatsDate			: '',
				timeZone			: '',
				languageInterface	: '',
				courseLanguages		: []
			},
			isValidTimeZone	: false
		}
	},
	components: {
		MainSelect,
		MultipleSelect,
		Autocomplete
	},
	created() {
		this.seo.title = this.$t(camelCase(this.$route.name));
		
		this.setDefaultData();
		
		if (!this.languageInterface.length) {
			this.fetchInterfaceLanguage().then(() => {
				this.payload.languageInterface = this.languageInterface.find(e => e.value === this.user.languageInterface.value)
			})
		} else {
			this.payload.languageInterface = this.languageInterface.find(e => e.value === this.user.languageInterface.value)
		}
		
		if (!this.timeZones.length) {
			this.fetchTimeZones({keywords: this.payload.timeZone.name})
		}
		
		if (!this.formatsDate.length) {
			this.fetchFormatsDate();
		}
		
		if (!this.basicCountries.length) {
			this.fetchBasicCountries().then(() => {
				this.payload.courseLanguages = intersectionBy(this.basicCountries, this.user.setting.data.coursesLanguages, 'slug')
			})
		} else {
			this.payload.courseLanguages = intersectionBy(this.basicCountries, this.user.setting.data.coursesLanguages, 'slug')
		}
	},
	computed: {
		...mapGetters({
			basicCountriesLoading	: 'userSetting/basicCountriesLoading',
			basicCountries			: 'userSetting/basicCountries',
			languageInterface		: 'userSetting/languageInterface',
			languageInterfaceLoading: 'userSetting/languageInterfaceLoading',
			formatsDate				: 'userSetting/formatsDate',
			formatsDateLoading		: 'userSetting/formatsDateLoading',
			updateSettingLoading	: 'userSetting/updateSettingLoading',
			user					: 'user/user',
			timeZones				: 'setting/timezones',
			timeZonesLoading		: 'setting/timezonesLoading',
		}),
		isHasChanges() {
			if (this.user) {
				return this.user.defaultCountry.id === this.payload.country.id &&
					this.user.timeZone.name === this.payload.timeZone.name &&
					this.payload.courseLanguages === this.user.setting.data.coursesLanguages &&
					this.user.languageInterface.value === this.payload.languageInterface.value &&
					this.user.formatsDate.id === this.payload.formatsDate.id
			}
		}
	},
	methods: {
		setDefaultData() {
			let userUtc = this.user.setting.data.timezone.data.utcOffsetShort;
			
			let zoneName = `(GTM ${userUtc}) ${this.user.timeZone.name}`;
			
			this.payload.timeZone = {
				id	: this.user.timeZone.id,
				name: zoneName
			};
			
			this.payload.country			= this.user.defaultCountry;
			this.payload.languageInterface	= this.user.languageInterface;
			this.payload.formatsDate		= this.user.formatsDate;
			this.payload.courseLanguages	= intersectionBy(this.basicCountries, this.user.setting.data.coursesLanguages, 'slug')
			
			if (this.languageInterface.length > 0) {
				//this.languageInterface = this.languageInterface.filter((e) => {return e.value != "ru"})
				
				this.payload.languageInterface = this.languageInterface.find(e => e.value === this.user.languageInterface.value)
			}
		},
		...mapActions({
			fetchInterfaceLanguage	: 'userSetting/SETTING_GET_LANGUAGE_INTERFACE',
			fetchTimeZones			: 'setting/GET_TIMEZONES',
			fetchFormatsDate		: 'userSetting/SETTING_GET_FORMATS_DATE',
			fetchBasicCountries		: 'userSetting/SETTING_GET_BASIC_COUNTRIES',
			update					: 'userSetting/SETTING_UPDATE',
			fetchUser				: `user/GET_USER_DATA`,
		}),
		createFormData() {
			console.log(this.payload.timeZone);
			
			let data = new FormData();
			
			data.append('interface_language', this.payload.languageInterface.value);
			// data.append('country_id', this.payload.country.id);
			data.append('timezone_id', this.payload.timeZone.id);
			data.append('courses_languages', this.payload.courseLanguages.map(e => e.slug));
			data.append('_method', 'patch');
			
			return data
		},
		updateRequest() {
			this.update(this.createFormData()).then(() => {
				this.$toasted.success(this.$t('successUpdateSetting'));
				
				this.fetchUser()
				
				translationUtils.setInterfaceLanguage(this.user.languageInterface.value)
				
				this.$router.push({
					name: 'profile-settings',
					params: {
						lang: this.user.languageInterface.value
					}
				})
			}).catch(error => {
				if (error.response && error.response.status === 422) {
					const errors = error.response.data.validation;
					
					Object.values(errors).forEach(e => {
						e.forEach(t => {
							this.$toasted.error(t)
						})
					})
				}
			});
		}
	}
}
